import React from "react";
import { CheckCircle2, Sparkles } from "lucide-react";
import "./ProgramDetails.custom.css";

const CourseOverview = ({ course, fetchCourse }) => {
  const duration = course?.Duration || fetchCourse?.Duration || "";
  const projectsCount = fetchCourse?.courseProject?.length || 0;
  const isAiCategory = (course?.category || "").toLowerCase().includes("ai") || (course?.category || "").toLowerCase().includes("generative") || (course?.CourseName || "").toLowerCase().includes("ai");

  // Dynamically generate features
  const keyFeatures = [
    { id: 1, text: `Earn a prestigious program completion certificate from yslearn Engineering` },
    { id: 2, text: "Access to all online/offline learning resources, session recordings, and PDF slide decks" }
  ];

  if (duration) {
    keyFeatures.push({
      id: 3,
      text: `${duration}+ hours of core curriculum delivered in live online classes by industry experts`
    });
  } else {
    keyFeatures.push({
      id: 3,
      text: "Comprehensive instruction delivered in live online classes by industry experts"
    });
  }

  if (projectsCount > 0) {
    keyFeatures.push({
      id: 4,
      text: `Master concepts with ${projectsCount} industry-relevant hands-on projects and case studies`
    });
  } else {
    keyFeatures.push({
      id: 4,
      text: "Build practical, job-ready capabilities through hands-on exercises and case studies"
    });
  }

  if (isAiCategory) {
    keyFeatures.push({
      id: 5,
      text: "Gain hands-on exposure to modern AI tools including ChatGPT, Hugging Face, Gemini, and LangChain"
    });
  } else {
    keyFeatures.push({
      id: 5,
      text: "Master modern tools, libraries, and frameworks recommended by active industry recruiters"
    });
  }

  keyFeatures.push({
    id: 6,
    text: "Receive regular learning feedback, direct peer group interaction, and career placement support"
  });

  return (
    <section id="programdetails" className="overview-section">
      <div className="overview-container">
        <div className="overview-grid">
          
          {/* Left Column: Description */}
          <div className="overview-desc-block text-left">
            <span className="pd-badge mb-4">
              <Sparkles size={11} className="text-blue-500 animate-pulse" />
              Course Overview
            </span>
            <h3 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
              About the {course.CourseName} Program
            </h3>
            <div className="overview-desc-text mt-6 bg-white/50 backdrop-blur-sm border border-gray-100 p-6 rounded-3xl leading-relaxed">
              <div dangerouslySetInnerHTML={{ __html: course?.Description }} />
            </div>
          </div>

          {/* Right Column: Key Features Card */}
          <div className="overview-features-block bg-white/70 border border-gray-100/80 rounded-3xl p-8 shadow-sm text-left">
            <h3 className="flex items-center gap-2 text-xl font-bold text-gray-900 mb-6">
              <Sparkles size={18} className="text-amber-500 animate-pulse" />
              Key Features
            </h3>
            <div className="flex flex-col gap-4">
              {keyFeatures.map((feature) => (
                <div key={feature.id} className="flex items-start gap-3 p-3 hover:bg-gray-50/50 rounded-2xl transition-colors duration-200">
                  <div className="flex-shrink-0 w-6 h-6 bg-blue-50 rounded-lg flex items-center justify-center text-blue-600 mt-0.5">
                    <CheckCircle2 size={14} className="stroke-[2.5]" />
                  </div>
                  <p className="text-sm font-bold text-gray-700 leading-normal">{feature.text}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CourseOverview;
